import React, { useEffect, useMemo, useRef } from 'react';

import { Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import { menuSectionStore } from '../../../store/menuSectionStore';
import { applicationStore } from '../../../store/applicationStore';
import BlackLayer from '../blackLayer';
import { getGameImages } from '../../../core/helpers/getGameImages';

const MobileGameLayer = observer(() => {
  const ref = useRef();
  const { isShowMenuPopup } = menuSectionStore;
  const { isShowBlackLayer } = applicationStore;

  const { background } = useMemo(() => {
    return getGameImages();
  }, []);

  useEffect(() => {
    if (ref.current && !isShowBlackLayer) {
      ref.current.width = window.innerWidth;
      ref.current.height = window.innerHeight;
    }
  }, [isShowBlackLayer]);

  return isShowBlackLayer ? (
    <BlackLayer />
  ) : (
    <Sprite visible={isShowMenuPopup} ref={ref} texture={background} />
  );
});
export default MobileGameLayer;
